<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-softball`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c12.15 0 22 9.85 22 22s-9.85 22-22 22S2 36.15 2 24 11.85 2 24 2zm1.089 4.032l-.048.378c-.206 1.5-.527 2.95-.963 4.35l3.054 1.49a1 1 0 01.46 1.337l-.877 1.798a1 1 0 01-1.337.46l-2.79-1.362a26.032 26.032 0 01-1.725 2.971l2.34 1.896a1 1 0 01.147 1.406l-1.258 1.554a1 1 0 01-1.407.148l-2.287-1.852a26.69 26.69 0 01-2.79 2.678l1.79 2.21a1 1 0 01-.148 1.407l-1.555 1.259a1 1 0 01-1.406-.148l-1.963-2.424a26.152 26.152 0 01-5.851 2.532c1.824 7.796 8.717 13.641 17.013 13.873a26.616 26.616 0 011.257-5.257l-2.929-1.69a1 1 0 01-.366-1.366l1-1.732a1 1 0 011.366-.366l2.558 1.476a26.52 26.52 0 012.08-3.248l-2.41-2.17a1 1 0 01-.073-1.412l1.338-1.487a1 1 0 011.412-.074l2.348 2.113a26.014 26.014 0 012.808-2.445l-1.872-2.484a1 1 0 01.197-1.4l1.597-1.204a1 1 0 011.4.197l2.07 2.745a26.308 26.308 0 014.366-1.81C40.03 12.519 33.3 6.522 25.089 6.032zm16.91 18.158l-.369.16c-3.652 1.624-6.695 3.887-9.129 6.788-2.511 2.993-4.247 6.513-5.206 10.56C35.603 40.162 41.91 32.92 42 24.19zM21.347 6.195l-.267.04C12.528 7.632 6 15.054 6 24c0 .134.001.268.004.4 4.055-1.643 7.397-4.034 10.028-7.169 2.61-3.11 4.381-6.789 5.315-11.036z"/></svg>
</template>
<script>

export default {
  name: 'IconSoftball',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
